import { isDefined, uncapitalize } from 'remeda';
import type { ZodType } from 'zod/v4';

export function handleZodError(
  zodResult: ReturnType<ZodType['safeParse']>,
  resourceName?: string,
  errorMessage?: string,
) {
  console.error(`Zod error while parsing ${resourceName}:`, zodResult.error?.message);

  void import('@sentry/react').then(({ captureMessage }) =>
    captureMessage(
      `Zod error while parsing ${isDefined(resourceName) ? resourceName : 'a'} response. Details attached to sentry event.`,
      { extra: { zodError: zodResult.error } },
    ),
  );

  const message = (() => {
    if (errorMessage) return errorMessage;
    if (isDefined(resourceName))
      return `An error occurred while loading the ${uncapitalize(resourceName)}. Our team has been notified.`;
    return 'An error occurred while loading a part of this page. Our team has been notified.';
  })();

  void import('@mantine/notifications').then(({ notifications }) =>
    notifications.show({
      title: resourceName ?? 'Error',
      color: 'red',
      message,
    }),
  );
}
